import type {
  Activity,
  Analysis,
  ForumCategory,
  ForumComment,
  ForumPost,
  ForumUser,
  GarminWorkout,
  Lap, // Added Lap
  User,
  Workout,
} from '@trainme/db/client';

export type GarminStrengthSet = {
  id: number;
  activityId: number;
  userId: string;
  garminApiUserId: string;
  setIndex: number;
  setType: string | null;
  durationType: string | null;
  durationValue: number | null;
  durationValueType: string | null;
  exerciseCategory: string | null;
  exerciseName: string | null;
  weightValue: number | null;
  weightDisplayUnit: string | null;
  repetitionValue: number | null;
  targetType: string | null;
  isRest: boolean | null;
  rawStep: unknown;
  startTimeInSeconds: number | null;
};

export type MapField = {
  id: string;
  polyline?: string;
  resourceState: number;
  summaryPolyline?: string;
};

export type ActivityWithRelations = Activity & {
  garminId?: number | null;
  laps?: Lap[];
  strengthSets?: GarminStrengthSet[];
  stravaId?: number | null;
}; // Changed StravaLap to Lap
export type WorkoutWithRelations = Workout & {
  analysis?: Analysis | null;
  garminWorkout?: GarminWorkout;
};
export type ForumPostWithRelations = ForumPost & {
  author: ForumUser & { user: User };
  comments: ForumCommentWithRelations[];
};
export type ForumCommentWithRelations = ForumComment & {
  author: ForumUser & { user: User };
};
export type ForumCategoryWithRelations = ForumCategory & {
  posts: ForumPostWithRelations[];
};

// The calendar view, lowercase to match the URL params
export enum View {
  Week = 'week',
  Month = 'month',
  Day = 'day',
}
